import React from 'react'

import Base from '../_Base'

const Mature = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M16.0298507,2 L22,7.8 L22,16.1 L16.1293532,22 L7.87064677,22 L2,16.1 L2,7.8 L7.87064677,2 L16.0298507,2 Z M15.3,4 L8.7,4 L4,8.7 L4,15.3 L8.7,20 L15.3,20 L20,15.3 L20,8.7 L15.3,4 Z M17,11 L17,13 L7,13 L7,11 L17,11 Z"
      fillRule="evenodd"
    />
  </Base>
)

export default Mature
